module.exports = __webpack_public_path__ + "static/media/_nato.7d2d4955.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/country-flags/_nato.svg
// module id = 2340
// module chunks = 7